import { generateActions } from 'redux-crud-resources';
import { CRUDABLE_RESOURCES } from '../constants';

export const CRUD_ACTIONS = generateActions(CRUDABLE_RESOURCES);

module.exports = {
  ...CRUD_ACTIONS,

  // sessions
  GET_ALL_SESSIONS_SUCCESS: 'success: get all sessions',
  GET_ALL_SESSIONS: 'get all sessions',
  GET_ALL_SESSIONS_ERROR: 'error: get all sessions',
};


// WEBPACK FOOTER //
// ./src/js/GameDay/actions/index.js